import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { FreightsCompany } from "./freights-company-entity";
import { FreightsCompanyController } from "./freights-company-controller";
import { FreightsCompanyService } from "./freights-company-service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";

@Module({
    imports:[TypeOrmModule.forFeature([FreightsCompany])],
    controllers:[FreightsCompanyController],
    providers:[FreightsCompanyService,ApplicationExceptionHandler]
})
export class FreightsCompanyModule{}